import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import useLocalStorageState from 'use-local-storage-state';
import { INNERHEIGHT } from '../constants/localStorage';

export const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [innherHeight, setInnherHeight] = useLocalStorageState(INNERHEIGHT, {
    defaultValue: 0,
  });
  function handleResize() {
    const isMobile = getIsMobile();
    setIsMobile(isMobile);

    if (isMobile) {
      setRemUnit();
    } else {
      const docEl = document.documentElement;
      docEl.style.fontSize = 'min(1vw, 1.6vh)'; // 恢复默认的字体大小
    }
  }
  useEffect(() => {
    // add event listener
    window.addEventListener('resize', handleResize);
    // initial state
    handleResize();
    if (!innherHeight) {
      setInnherHeight(Math.max(window.innerHeight, 610));
    }
    // remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const setRemUnit = () => {
    const baseSize = 10; // 基础字体大小（可以根据需要调整）
    const docEl = document.documentElement;
    const clientWidth = docEl.clientWidth;
    const scale = clientWidth / 390; // 设计稿的宽度，可以根据实际情况调整
    docEl.style.fontSize = baseSize * Math.min(scale, 2) + 'px'; // 限制最大放大比例为2
  };

  return {
    isMobile,
  };
};
const isMobileDevice = () => {
  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  );
};
export function getIsMobile() {
  const windowSize = {
    width: window.innerWidth,
    height: window.innerHeight,
  };
  const isMobile =
    (typeof windowSize?.width === 'number' && windowSize?.width < 600) ||
    isMobileDevice();
  return isMobile;
}

// is mobile
export const useIsMobile = () => {
  const { isMobile } = useSelector((state: RootState) => state.common);
  if (!isMobile) {
    const isMobile =
      (typeof window.innerWidth === 'number' && window.innerWidth < 600) ||
      isMobileDevice();
    return { isMobile };
  }
  return { isMobile };
};
